export default __webpack_public_path__ + "static/media/widget_watchbox_vpmes60f_buy.4ea734ad.mp3";